module.exports = __webpack_public_path__ + "static/media/mazya final edit shot 01-mobile.26ebc585.webp";